var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0015 19.1641H10.0008C8.59927 19.166 7.21835 18.8264 5.97749 18.1747L5.80623 18.0848L5.61903 18.1335L1.68701 19.1573L1.68697 19.1573C1.63991 19.1696 1.59046 19.1693 1.54353 19.1566L1.41254 19.6391L1.54353 19.1566C1.49659 19.1439 1.4538 19.1191 1.4194 19.0847C1.38499 19.0503 1.36017 19.0076 1.34738 18.9606L0.86545 19.092L1.34738 18.9606C1.3346 18.9137 1.33429 18.8643 1.34648 18.8173C1.34649 18.8173 1.3465 18.8172 1.34651 18.8172L2.36929 14.8864L2.41804 14.6991L2.32792 14.5278C1.67451 13.2856 1.33401 11.9028 1.33595 10.4992V10.4986C1.33595 5.71257 5.2155 1.83301 10.0015 1.83301C14.7875 1.83301 18.667 5.71257 18.667 10.4986C18.667 15.2845 14.7875 19.1641 10.0015 19.1641Z",
  stroke: "#00538F"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_8740_67652)"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 20,
  height: 20,
  fill: "#00538F"
}));

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8740_67652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 20,
    height: 19
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.689fbb95.svg";
export { ForwardRef as ReactComponent };